(function(angular) {
    'use strict';

    var serviceName = 'FinancialCenterService';
    var mainRoute = 'financialcenters';

    angular.module('aprima-provider-api').factory(serviceName, [
        '_',
        '$q',
        'AprimaAnalytics',
        'AprimaCache',
        'AprimaRestangular',
        'ServerInfoRepository',
        FinancialCenterService,
    ]);

    function FinancialCenterService(
        _,
        $q,
        AprimaAnalytics,
        AprimaCache,
        AprimaRestangular,
        ServerInfoRepository
    ) {
        var defaultCache = AprimaCache.Default.httpMode;

        var service = {
            getDefault: getDefault,
        };

        return service;

        function getDefault(defaultToMain, providerId, serviceSiteId, calendarId) {
            var params = {
                defaultToMain: !!defaultToMain,
                providerId: providerId,
                serviceSiteId: serviceSiteId,
                calendarId: calendarId,
            };
            var result = get('default', params, 'DefaultFinancialCenter', defaultCache);
            return result;
        }

        function get(route, params, requiredFeature, cache) {
            if(requiredFeature && !ServerInfoRepository.isFeatureSupported(requiredFeature)) {
                return $q.when(null);
            }

            var timing = AprimaAnalytics.startTiming(serviceName, 'api', route);
            var result = AprimaRestangular.get()
                .one(mainRoute, route)
                .withHttpConfig({cache: cache})
                .get(params)
                .finally(timing.stop);

            return result;
        }
    }

})(window.angular);
